import { BaseBetslipGroupPick } from '../../../../../core/picks/betslip-group-pick';
import { BetslipV1Pick } from '../../../../../core/picks/betslip-v1-pick';
import { BetslipV2Pick } from '../../../../../core/picks/betslip-v2-pick';
import { PriceType } from '../../../../../core/picks/pick-models';
import { OddsChanged } from '../../../errors/result/odds-changed';
import { PickUpdaterBase } from './pick-updater';

export default class BetslipErrorOddsChangedUpdater extends PickUpdaterBase<OddsChanged> {
    protected updateV1Pick(pick: BetslipV1Pick, error: OddsChanged): void {
        pick.priceHistory.push({ ...pick.currentPrice! });
        pick.option.price.nativeOdds = error.currentOdds;
    }

    protected updateV2Pick(pick: BetslipV2Pick, error: OddsChanged): void {
        pick.priceHistory.push({ ...pick.currentPrice! });
        const priceToChange = pick.prices.find((price) => price.type === PriceType.Fixed);
        if (priceToChange === undefined) {
            return;
        }
        priceToChange.nativeOdds = error.currentOdds; // we can modify directly the odds, this is a copy of the price
    }

    protected updateGroupPick(pick: BaseBetslipGroupPick, error: OddsChanged): void {
        pick.priceHistory.push({ ...pick.currentPrice! });
        pick.setPrice({
            id: 1,
            isVisible: true,
            type: PriceType.Fixed,
            marketId: 1,
            nativeOdds: error.currentOdds,
        });
    }
}
